import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
// import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import InfoField from 'components/Ui/InfoField'
import { Modal, SimpleTable, Tabs } from 'components/Ui'
import { getApiDetails } from 'services/AsnService'
import { Button } from 'components/Form'
import dayjs from 'dayjs'
injectReducer('asn', reducer)

const View = () => {
    const { id } = useParams()
    // const dispatch = useDispatch()
    const navigate = useNavigate()
    const [detailsData, setDetailsData] = useState([])
    const [open, setOpen] = useState(false)
    const [data, setData] = useState()

    const { record, loading } = useSelector(state => state.asn.data)

    useEffect(() => {
        if (id) {
            // fetchData(id)
            getApiDetails({ asn_no: id })
                .then(response => {
                    setDetailsData(response.data.data?.sort((a, b) => a['Line No'] - b['Line No']))
                })
                .catch(error => console.log('Error:', error))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    // const fetchData = id => dispatch(getRecord(id))

    if (loading && id) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">ASN</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 flex justify-between py-3 border-b border-stroke dark:border-strokedark">
                        <h5 className="font-bold">Header</h5>
                        <Button
                            className="h-10 w-18 text-white border bg-[red] border-primary dark:text-secondary dark:border-secondary"
                            onClick={() => navigate('/meson-wms/asn')}
                        >
                            Back
                        </Button>
                    </div>
                    <div className="flex flex-col gap-3 py-6 px-6">
                        <div className="grid grid-cols-4 gap-4">
                            <InfoField title="Warehouse: " value={record?.Warehouse} />
                            <div></div>
                            <InfoField title="Company: " value={record?.Company} />
                            <div></div>
                            <InfoField title="Order Number: " value={record?.['Order No']} />
                            <div></div>
                            <InfoField title="Customer: " value={record?.Customer} />
                            <div></div>
                            <InfoField title="Receipt Type: " value={record?.['Receipt Type']} />
                            <div></div>
                            <InfoField title="Reference A: " value={record?.Ref_1} />
                            <div></div>
                            <InfoField title="Reference B: " value={record?.Ref_2} />
                            <div></div>
                            <InfoField title="Total Ordered Quantity: " value={record?.['Total Ordered Qty']} />
                            <div></div>
                            <InfoField title="Total Received Quantity: " value={record?.['Total Received Qty']} />
                            <div></div>
                            <InfoField
                                title="Create Date: "
                                value={record?.['Create Date'] ? dayjs(record?.['Create Date']).format('MMM D, YYYY') : ''}
                            />
                            <div></div>
                            <InfoField
                                title="Last Update: "
                                value={record?.['Last Update'] ? dayjs(record?.['Last Update']).format('MMM D, YYYY') : ''}
                            />
                            <div></div>
                            <InfoField title="Order Status: " value={record?.['Order Status']} />
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <Tabs.Group version={1}>
                        <Tabs.List>
                            <Tabs>Details</Tabs>
                        </Tabs.List>
                        <Tabs.Panels className="mt-4">
                            <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Line No.</SimpleTable.TH>
                                                <SimpleTable.TH>SKU</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                                <SimpleTable.TH>Quantity Ordered</SimpleTable.TH>
                                                <SimpleTable.TH>Quantity Received</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(detailsData ?? [])?.map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`asn-${index}`}
                                                    onClick={() => {
                                                        setOpen(true)
                                                        setData(item)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.['Line No']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.sku}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.skuDescr}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Expected Quantity']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Received Quantity']}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel>
                        </Tabs.Panels>
                    </Tabs.Group>
                </div>
                <Modal
                    show={open}
                    onClose={() => {
                        setOpen(false)
                    }}
                >
                    <div className="flex flex-col gap-1 m-3">
                        <h2 className="font-semibold text-black text-title-md">{'Details'}</h2>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                            <div className="flex flex-col gap-3 py-6 px-8">
                                <div className="grid grid-cols-1 gap-4">
                                    <InfoField grid={false} title="Wharehouse: " value={data?.warehouseId} />
                                    <InfoField grid={false} title="Company: " value={data?.organizationId} />
                                    <InfoField grid={false} title="ASN Number: " value={data?.asnNo} />
                                    <InfoField grid={false} title="Customer: " value={data?.customerId} />
                                    <InfoField grid={false} title="Line No.: " value={data?.asnLineNo} />
                                    <InfoField grid={false} title="Product: " value={data?.sku} />
                                    <InfoField grid={false} title="Expected Quantity: " value={data?.expectedQty} />
                                    <InfoField grid={false} title="Received Quantity: " value={data?.receivedQty} />
                                    <InfoField grid={false} title="Pack Id: " value={data?.packId} />
                                    <InfoField grid={false} title="Pack UOM: " value={data?.packUom} />
                                    <InfoField grid={false} title="Receiving at: " value={data?.receivedTime} />
                                    <InfoField grid={false} title="Hold Reject Code: " value={data?.holdRejectCode} />
                                    <InfoField grid={false} title="Hold Reject Reason: " value={data?.holdRejectReason} />
                                    <InfoField
                                        grid={false}
                                        title="Product Status Description: "
                                        value={data?.productStatus_Descr}
                                    />
                                    <InfoField grid={false} title="Receiving Location: " value={data?.receivingLocation} />
                                    <InfoField grid={false} title="Total Cubic: " value={data?.totalCubic} />
                                    <InfoField grid={false} title="Total Gross-Weight: " value={data?.totalGrossWeight} />
                                    <InfoField grid={false} title="Total Net-Weight: " value={data?.totalNetWeight} />
                                    <InfoField grid={false} title="Total Price: " value={data?.totalPrice} />
                                    <InfoField grid={false} title="Rejected Qty: " value={data?.rejectedQty} />
                                    <InfoField grid={false} title="Description: " value={data?.skuDescr} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    )
}

export default View
